// extracted by mini-css-extract-plugin
export default {"title":"Context_title__PvYR4","content":"Context_content__PFbfm","itemName":"Context_itemName__rNZWN"};